import { IConstraintFacilityConstrainedScheduleDetail } from '../../interfaces/iconstraint-facility-constrained-schedule-detail';
import { Area } from '../area';
import { ConstraintFacilityConstrainedSchedule } from '../constraint-facility-constrained-schedule';

export class ConstraintFacilityConstrainedScheduleDetailBase {
  ConstraintFacilityConstrainedScheduleDetailId: number;
  ConstraintFacilityConstrainedScheduleId: number;
  AreaId: number | null;
  ChokeAllowed: boolean | null;
  FracSlide: number | null;
  PopSlide: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintFacilityConstrainedSchedule?: ConstraintFacilityConstrainedSchedule;

  constructor(item?: IConstraintFacilityConstrainedScheduleDetail) {
    if (item) {

      this.ConstraintFacilityConstrainedScheduleDetailId = item.ConstraintFacilityConstrainedScheduleDetailId;
      this.ConstraintFacilityConstrainedScheduleId = item.ConstraintFacilityConstrainedScheduleId;
      this.AreaId = item.AreaId;
      this.ChokeAllowed = item.ChokeAllowed;
      this.FracSlide = item.FracSlide;
      this.PopSlide = item.PopSlide;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintFacilityConstrainedSchedule = new ConstraintFacilityConstrainedSchedule(item.ConstraintFacilityConstrainedSchedule);
    }
  }
}